import React from 'react';
import infoImage from '../../assets/info.svg';

const HoverInfo = ({ content }) => {
  return (
    <div className="relative inline-block group">
      &nbsp;
      <img src={infoImage} alt="Info" className="inline" />
      <div className="absolute left-0 top-full mt-2 hidden group-hover:inline-block">
        <div className="bg-gray-800 relative z-[100] text-white text-[12px] w-32 p-2 rounded shadow-lg">
          {content}
        </div>
      </div>
    </div>
  );
};

export default HoverInfo;
